import { api } from './api'

export interface FormularyMedication {
  tenantId: string
  medicationId: string
  addedAt: string
  [key: string]: any // Allow additional metadata
}

export interface FormularyCheckResult {
  medicationId: string
  inFormulary: boolean
}

/** Medication reference shape returned for ATC-matched formulary alternatives */
export interface FormularyAlternativeReference {
  tenantId: string
  drugIdPK: string
  productName: string
  strength?: string
  dosageForm?: string
  routesOfAdministration?: string[]
  atcCodes?: string[]
  gmsReimbursable?: boolean
  licenceNumber?: string
}

export interface FormularyAlternativesResult {
  referenceDrugId: string
  alternatives: FormularyAlternativeReference[]
}

export const formularyService = {
  /**
   * Get all formulary medications
   */
  getFormularyMedications: async (): Promise<FormularyMedication[]> => {
    const response = await api.get<FormularyMedication[]>('/formulary')
    return response.data
  },

  /**
   * Check if a medication is in the formulary
   */
  checkFormulary: async (medicationId: string): Promise<FormularyCheckResult> => {
    const response = await api.get<FormularyCheckResult>(`/formulary/check/${encodeURIComponent(medicationId)}`)
    return response.data
  },

  /**
   * Formulary-listed medications with overlapping ATC codes (therapeutic alternatives on formulary).
   */
  getFormularyAlternatives: async (referenceDrugId: string): Promise<FormularyAlternativesResult> => {
    const response = await api.get<FormularyAlternativesResult>(
      `/formulary/alternatives/${encodeURIComponent(referenceDrugId)}`,
    )
    return response.data
  },

  /**
   * Add medication to formulary
   */
  addToFormulary: async (medicationId: string, metadata?: Record<string, any>): Promise<FormularyMedication> => {
    const response = await api.post<FormularyMedication>('/formulary', {
      medicationId,
      ...metadata,
    })
    return response.data
  },

  /**
   * Remove medication from formulary
   */
  removeFromFormulary: async (medicationId: string): Promise<void> => {
    await api.delete(`/formulary/${encodeURIComponent(medicationId)}`)
  },
}
